import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { DatastoreRecommendedUsernamesModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FormLogoModule } from '../form-logo/form-logo.module';
import { LoginSignupButtonsModule } from '../login-signup-buttons.module';
import { UsernameSelectFormComponent } from './username-select-form.component';
import { LoginSignupErrorsModule } from '../login-signup-errors/login-signup-errors.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DatastoreRecommendedUsernamesModule,
    LoginSignupButtonsModule,
    LoginSignupErrorsModule,
    FormLogoModule,
    UiModule,
    TrackingModule,
  ],
  declarations: [UsernameSelectFormComponent],
  exports: [UsernameSelectFormComponent],
})
export class UsernameSelectModule {}
